var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtoeSearchJobsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.9 57.2",
    style: {
      enableBackground: "new 0 0 64.9 57.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BFDDF1;}\n\t.st1{fill:#FFD392;}\n\t.st2{fill:#7FBAE3;}\n\t.st3{fill:#2A3953;}\n\t.st4{fill:#D3E5F6;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#4099D6;}\n\t.st7{fill:#FFE2B6;}\n\t.st8{fill:#EF6552;}\n\t.st9{fill:#BFE5CD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    transform: "translate(-1729.96 -1657.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2233",
    transform: "translate(1729.96 1657.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    transform: "translate(0 1.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    transform: "translate(1.015 26.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1480",
    className: "st0",
    d: "M8.6,0h20.5c2.8,0,5,2.2,5,5v10.3l0,0H3.6l0,0V5C3.6,2.2,5.9,0,8.6,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    transform: "translate(13.941 30.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    className: "st1",
    d: "M3.6,0c0,0,2.5,1.8,4.6,0L5.9,8.6L3.6,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    transform: "translate(7.393 1.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    className: "st2",
    d: "M21.4,15.6V8.9c0-4.9-4-8.9-8.9-8.9l0,0l0,0C7.6,0,3.6,4,3.6,8.9l0,0v6.8L21.4,15.6 L21.4,15.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    transform: "translate(6.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    className: "st3",
    d: "M22.4,17.7H4.6c-0.6,0-1-0.5-1-1l0,0V9.9c0-5.5,4.4-9.9,9.8-10c5.5-0.1,9.9,4.3,10,9.8 c0,0.1,0,0.1,0,0.2v6.8C23.4,17.2,22.9,17.7,22.4,17.7z M5.7,15.6h15.7V9.9C21.4,5.6,18,2,13.6,2C9.3,2,5.7,5.4,5.7,9.8 c0,0.1,0,0.1,0,0.2L5.7,15.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    transform: "translate(5.676 13.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1481",
    className: "st4",
    d: "M6.3,0H22c1.5,0,2.7,1.2,2.7,2.7l0,0c0,1.5-1.2,2.7-2.7,2.7H6.3 c-1.5,0-2.7-1.2-2.7-2.7l0,0C3.6,1.2,4.8,0,6.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    transform: "translate(4.662 12.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    className: "st3",
    d: "M23.1,7.5H7.4c-2.1,0-3.7-1.7-3.7-3.7S5.3,0,7.4,0l0,0h15.7c2.1,0,3.7,1.7,3.7,3.7 S25.1,7.5,23.1,7.5z M7.4,2c-1,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7h15.7c0.9,0,1.7-0.8,1.7-1.7S24,2,23.1,2H7.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    transform: "translate(0 25.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    className: "st3",
    d: "M35.1,17.3H4.6c-0.6,0-1-0.5-1-1l0,0V6.2C3.6,2.8,6.4,0,9.8,0h20.1c3.4,0,6.2,2.8,6.2,6.2 v10.1C36.1,16.8,35.7,17.3,35.1,17.3z M5.7,15.3h28.4V6.2c0-2.3-1.9-4.1-4.1-4.1H9.8C7.5,2,5.7,3.9,5.7,6.2V15.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    transform: "translate(6.185 35.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    className: "st3",
    d: "M4.6,7.2c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.5-1,1-1s1,0.4,1,1v5.2C5.7,6.8,5.2,7.2,4.6,7.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    transform: "translate(12.848 22.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1482",
    className: "st5",
    d: "M3.6,0h6.8l0,0v6c0,1.9-1.5,3.4-3.4,3.4l0,0C5.1,9.4,3.6,7.9,3.6,6V0L3.6,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    transform: "translate(11.833 21.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    className: "st3",
    d: "M8,11.5c-2.4,0-4.4-2-4.4-4.4V1c0-0.6,0.5-1,1-1l0,0h6.8c0.6,0,1,0.5,1,1l0,0v6 C12.4,9.5,10.5,11.5,8,11.5z M5.7,2v5c0,1.3,1.1,2.4,2.4,2.4l0,0c1.3,0,2.4-1.1,2.4-2.4V2H5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    transform: "translate(8.632 8.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    className: "st5",
    d: "M14.3,0C11.5,3.1,6.1,4.3,3.7,4.7c0,0.4-0.1,0.8-0.1,1.1v3.5c0,4.2,3.4,7.6,7.6,7.6l0,0l0,0 c4.2,0,7.6-3.4,7.6-7.6V5.8c0-0.4,0-0.7-0.1-1.1C16.8,3.8,15.2,2.1,14.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    transform: "translate(11.812 13.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    className: "st3",
    d: "M4.6,3.5c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0,0,0,0,0.1v1.5 C5.7,3.1,5.2,3.5,4.6,3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    transform: "translate(6.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    className: "st3",
    d: "M4.6,3.5c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0,0,0,0,0.1v1.5 C5.7,3.1,5.2,3.5,4.6,3.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    transform: "translate(7.617 7.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    className: "st3",
    d: "M12.3,19c-4.8,0-8.6-3.9-8.6-8.6V6.9c0-0.4,0-0.9,0.1-1.3c0.1-0.4,0.4-0.8,0.8-0.8 c2.1-0.4,7.4-1.5,10-4.4C15,0,15.6,0,16,0.3c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.8,2.2,3.3,3.9,4.2c0.3,0.2,0.5,0.4,0.5,0.8 c0.1,0.4,0.1,0.8,0.1,1.2v3.5C20.9,15.2,17,19,12.3,19z M5.7,6.6c0,0.1,0,0.2,0,0.3v3.5c0.1,3.6,3.2,6.5,6.8,6.4 c3.5-0.1,6.2-2.9,6.4-6.4V6.9c0-0.1,0-0.3,0-0.4c-1.6-1-2.9-2.3-3.9-3.8C13.4,4,10.5,5.6,5.7,6.6L5.7,6.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    transform: "translate(7.393 26.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    className: "st6",
    d: "M6.1,0L3.6,5H7L5.3,7.6l7.2,5L9.1,0H6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    transform: "translate(6.378 25.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    className: "st3",
    d: "M13.5,14.7c-0.2,0-0.4-0.1-0.6-0.2l-7.2-5C5.3,9.2,5.2,8.6,5.5,8.1L6.2,7H4.7 c-0.6,0-1-0.5-1-1c0-0.2,0-0.3,0.1-0.4l2.4-5C6.4,0.2,6.7,0,7.1,0h3c0.5,0,0.9,0.3,1,0.8l3.4,12.7c0.1,0.5-0.2,1.1-0.7,1.2 C13.7,14.7,13.6,14.7,13.5,14.7L13.5,14.7z M7.7,8.4l4.1,2.9L9.3,2H7.7L6.3,5H8c0.6,0,1,0.5,1,1c0,0.2-0.1,0.4-0.2,0.5L7.7,8.4z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    transform: "translate(16.251 26.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    className: "st6",
    d: "M10,0l2.4,5H9.2l1.7,2.7l-7.2,5L7,0H10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    transform: "translate(15.236 25.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    className: "st3",
    d: "M4.6,14.7c-0.6,0-1-0.5-1-1c0-0.1,0-0.2,0-0.3L7.1,0.8C7.2,0.3,7.6,0,8,0h3 c0.4,0,0.7,0.2,0.9,0.6l2.4,5c0.2,0.5,0,1.1-0.5,1.4c0,0-0.1,0-0.3,0H12l0.7,1.1c0.3,0.5,0.2,1.1-0.3,1.4l-7.2,5 C5.1,14.6,4.9,14.7,4.6,14.7z M8.8,2l-2.5,9.2l4.1-2.9L9.3,6.5C9,6.1,9.2,5.4,9.6,5.1C9.8,5,10,5,10.2,5h1.7l-1.5-3H8.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    transform: "translate(15.236 38.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    className: "st3",
    d: "M4.6,4.6c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0,0,0,0,0.1v2.6 C5.7,4.2,5.2,4.6,4.6,4.6L4.6,4.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    transform: "translate(30.456 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    transform: "translate(0 3.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    transform: "translate(3.808 1.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    className: "st7",
    d: "M13.4,0L13.4,0C8,0,3.6,4.4,3.6,9.8l0,0v18.1h19.6V9.8C23.2,4.4,18.9,0,13.4,0L13.4,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    transform: "translate(2.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    className: "st3",
    d: "M24.3,29.9H4.6c-0.6,0-1-0.5-1-1l0,0V10.8C3.6,4.8,8.5,0,14.5,0s10.8,4.8,10.8,10.8v18.1 C25.3,29.5,24.8,29.9,24.3,29.9z M5.7,27.9h17.6V10.8c-0.1-4.9-4-8.7-8.9-8.7C9.6,2.2,5.7,6,5.7,10.8V27.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    transform: "translate(1.015 26.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1483",
    className: "st0",
    d: "M8.6,0h15.2c2.8,0,5,2.2,5,5v9.4l0,0H3.6l0,0V5C3.6,2.2,5.9,0,8.6,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    transform: "translate(0 25.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    className: "st3",
    d: "M29.8,16.4H4.6c-0.6,0-1-0.5-1-1l0,0V7.1C3.6,3.2,6.8,0,10.8,0h12.9c3.9,0,7.1,3.2,7.1,7.1 v8.3C30.8,16,30.4,16.4,29.8,16.4z M5.7,14.4h23.1V7.1c0-2.8-2.3-5.1-5.1-5.1H10.8C7.9,2,5.7,4.3,5.7,7.1V14.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    transform: "translate(20.064 35.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    className: "st3",
    d: "M4.6,6.7c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.5-1,1-1s1,0.4,1,1v4.7C5.7,6.3,5.2,6.7,4.6,6.7 L4.6,6.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    transform: "translate(10.359 22.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1484",
    className: "st5",
    d: "M3.6,0h6.5l0,0v5.8C10.1,7.6,8.7,9,6.9,9l0,0l0,0C5.1,9,3.6,7.6,3.6,5.8l0,0V0L3.6,0z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    transform: "translate(9.345 21.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    className: "st3",
    d: "M7.9,11.1c-2.3,0-4.3-1.9-4.3-4.3V1c0-0.6,0.5-1,1-1l0,0h6.5c0.6,0,1,0.5,1,1l0,0v5.8 C12.1,9.1,10.2,11.1,7.9,11.1z M5.7,2v4.8C5.7,8,6.7,9,7.9,9s2.2-1,2.2-2.2V2H5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    transform: "translate(6.336 9.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    className: "st5",
    d: "M13.9,0C11.2,3,6,4.1,3.7,4.5c0,0.3-0.1,0.7-0.1,1.1V9c0,4,3.3,7.3,7.3,7.3l0,0 c4,0,7.3-3.3,7.3-7.3V5.6c0-0.3,0-0.7-0.1-1C16.2,3.6,14.7,2,13.9,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    transform: "translate(9.329 14.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    className: "st3",
    d: "M4.6,3.4c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0,0,0,0,0.1v1.4 C5.7,3,5.2,3.4,4.6,3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2220",
    transform: "translate(6.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    className: "st3",
    d: "M4.6,3.4c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0,0,0,0,0.1v1.4 C5.7,3,5.2,3.4,4.6,3.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2222",
    transform: "translate(5.321 8.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    className: "st3",
    d: "M11.9,18.3c-4.6,0-8.3-3.7-8.3-8.3V6.6c0-0.4,0-0.8,0.1-1.3c0.1-0.4,0.4-0.8,0.8-0.8 c2-0.3,7.1-1.4,9.6-4.2c0.4-0.4,1-0.4,1.4-0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.7,1.7,2.1,3.1,3.8,4c0.3,0.2,0.5,0.4,0.5,0.8 c0.1,0.4,0.1,0.8,0.1,1.2V10C20.2,14.6,16.5,18.3,11.9,18.3z M5.7,6.4c0,0.1,0,0.2,0,0.3V10c0,3.5,2.8,6.3,6.3,6.3 s6.3-2.8,6.3-6.3l0,0V6.6c0-0.1,0-0.3,0-0.4c-1.5-0.9-2.7-2.1-3.6-3.5c-1.4,1.1-2.9,1.9-4.6,2.5C8.6,5.7,7.1,6.1,5.7,6.4 L5.7,6.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    transform: "translate(6.336 29.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    className: "st6",
    d: "M7.6,0l-4,4.2l7.3,4.5V4.8L7.6,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    transform: "translate(13.611 29.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    className: "st6",
    d: "M6.9,0l4,4.2L3.6,8.6V4.8L6.9,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    transform: "translate(5.321 28.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    className: "st3",
    d: "M11.9,10.6c-0.2,0-0.4-0.1-0.5-0.2L4.1,6C3.6,5.7,3.5,5.1,3.8,4.6c0-0.1,0.1-0.1,0.1-0.2 l4-4.2c0.4-0.4,1-0.4,1.4,0c0,0,0.1,0.1,0.1,0.2l3.3,4.8c0.1,0.2,0.2,0.4,0.2,0.6v3.9C12.9,10.2,12.5,10.6,11.9,10.6L11.9,10.6 L11.9,10.6z M6.3,5l4.6,2.8V6.1L8.5,2.6L6.3,5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    transform: "translate(12.596 28.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    className: "st3",
    d: "M4.6,10.6c-0.6,0-1-0.5-1-1l0,0V5.8c0-0.2,0.1-0.4,0.2-0.6l3.3-4.8C7.4,0,8-0.1,8.5,0.2 c0.1,0,0.1,0.1,0.2,0.1l4,4.2c0.4,0.4,0.4,1,0,1.4C12.6,6,12.5,6,12.4,6l-7.3,4.5C5,10.6,4.8,10.6,4.6,10.6z M5.7,6.1v1.7 L10.3,5L8,2.6L5.7,6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    transform: "translate(12.596 37.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    className: "st3",
    d: "M4.6,7.8c-0.6,0-1-0.5-1-1l0,0V1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0,0,0,0,0.1v5.8 C5.7,7.4,5.2,7.8,4.6,7.8L4.6,7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    transform: "translate(6.488 1.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    className: "st0",
    d: "M17.9,0H3.6l1.2,9.6h11.7L17.9,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    transform: "translate(5.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    className: "st3",
    d: "M17.6,11.6H5.9c-0.5,0-0.9-0.4-1-0.9L3.6,1.1c0-0.5,0.4-1,0.9-1.1h0.1h14.2c0.6,0,1,0.5,1,1 v0.1l-1.2,9.6C18.6,11.3,18.1,11.6,17.6,11.6z M6.8,9.6h10l1-7.6h-12L6.8,9.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    transform: "translate(11.108 3.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    className: "st8",
    d: "M8.3,1.6H7V0.3C7,0.1,6.8,0,6.7,0l0,0H5.6C5.4,0,5.3,0.1,5.3,0.3l0,0v1.4H3.9 C3.7,1.7,3.6,1.8,3.6,2l0,0v1.1c0,0.2,0.1,0.3,0.3,0.3l0,0h1.4v1.4C5.3,4.9,5.4,5,5.6,5l0,0h1.1C6.8,5,7,4.9,7,4.7l0,0V3.4h1.4 c0.2,0,0.3-0.1,0.3-0.3l0,0V1.9C8.6,1.8,8.5,1.6,8.3,1.6L8.3,1.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    transform: "translate(1748.883 1694.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    transform: "translate(1.014 1.015)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    className: "st9",
    cx: 12.5,
    cy: 8.9,
    r: 8.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    className: "st3",
    d: "M13.5,19.8c-5.5,0-9.9-4.4-9.9-9.9S8.1,0,13.5,0c5.5,0,9.9,4.4,9.9,9.9l0,0 C23.4,15.4,19,19.8,13.5,19.8z M13.5,2C9.2,2,5.7,5.6,5.7,9.9s3.5,7.9,7.9,7.9s7.9-3.5,7.9-7.9C21.4,5.6,17.9,2,13.5,2L13.5,2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2240",
    transform: "translate(3.142 3.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2236",
    transform: "translate(1.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    className: "st3",
    d: "M14.6,7.8c-0.6,0-1-0.5-1-1l0,0c0-2.6-2.1-4.7-4.7-4.7C7.5,2,6.3,2.6,5.4,3.5 C5,3.9,4.4,3.9,4,3.5s-0.4-1,0-1.4c2.6-2.7,6.9-2.8,9.6-0.2c1.3,1.3,2.1,3,2.1,4.9C15.6,7.3,15.1,7.8,14.6,7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2237",
    transform: "translate(0 5.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    className: "st3",
    d: "M10.4,7.8c-3.7,0-6.8-3-6.8-6.8c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0,0,0,0,0.1 c0,2.6,2.1,4.7,4.7,4.7c1.3,0,2.5-0.5,3.3-1.4C14,4,14.6,4,15,4.4s0.4,1,0,1.4C13.9,7.1,12.2,7.8,10.4,7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2238",
    transform: "translate(0.805 1.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    className: "st3",
    d: "M5.4,1.1l1.1,1c0.1,0.1,0.1,0.3,0,0.4L6.4,2.6L5.3,2.8L3.9,3C3.8,3.1,3.7,3,3.6,2.8V2.7 l0.1-1.3l0.1-1.2C3.9,0.1,4,0,4.2,0c0.1,0,0.1,0,0.1,0.1L5.4,1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    transform: "translate(9.427 8.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    className: "st3",
    d: "M4.9,2.1L3.7,1c-0.1-0.1-0.1-0.3,0-0.4c0,0,0.1-0.1,0.2-0.1l1.2-0.2L6.5,0 c0.1,0,0.3,0.1,0.3,0.2v0.1L6.6,1.7L6.5,3c0,0.2-0.1,0.3-0.3,0.2c-0.1,0-0.1,0-0.2-0.1L4.9,2.1z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtoeSearchJobsIcon);
export default __webpack_public_path__ + "static/media/ltoe-search-jobs-icon.40005588cf4020fb557905adeda23ea0.svg";
export { ForwardRef as ReactComponent };